<template>
    <Head title="Education Applicant"></Head>
    <div class="grid">
        <div class="col-12">
            <div class="card">
                <Toast />
                <Toolbar class="mb-4">
                    <template v-slot:start>
                        <div class="my-2">
                            <Button
                                label="Tambah Pendidikan"
                                icon="pi pi-plus"
                                class="p-button-success mr-2"
                                @click="openNew"
                            />
                        </div>
                    </template>
                </Toolbar>

                <DataTable
                    ref="dt"
                    :value="models"
                    dataKey="id"
                    v-model:selection="selectedModels"
                    :rows="10"
                    :loading="loading"
                    :total-records="totalRecords"
                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                    :rowsPerPageOptions="[5, 10, 25]"
                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} models"
                    responsiveLayout="scroll"
                    @row-select="onRowSelect"
                    @row-unselect="onRowUnselect"
                >
                    <template #header>
                        <div
                            class="flex flex-column md:flex-row md:justify-content-between md:align-items-center"
                        >
                            <h5 class="m-0">Input Riwayat Pendidikan</h5>
                            <span class="block mt-2 md:mt-0 p-input-icon-left">
                                <i class="pi pi-search" />
                            </span>
                        </div>
                    </template>
                    <Column
                        field="name"
                        header="Name"
                        :sortable="true"
                        headerStyle="width:70%; min-width:10rem;"
                    >
                        <template #body="slotProps">
                            <span class="p-column-title">Name</span>
                            {{ slotProps.data.name }}
                        </template>
                    </Column>
                    <Column
                        field="education_level"
                        header="Level Pendidikan"
                        :sortable="true"
                        headerStyle="width:70%; min-width:10rem;"
                    >
                        <template #body="slotProps">
                            <span class="p-column-title">Level Pendidikan</span>
                            <!-- {{ slotProps.data.education_level }} -->
                            <Dropdown v-model="slotProps.data.education_level" :options="lastEducationLevels" optionLabel="name"
                            optionValue="id" placeholder="Pilih Level Pendidikan"/>
                        </template>
                    </Column>
                    <Column
                        field="major"
                        header="Jurusan"
                        :sortable="true"
                        headerStyle="width:70%; min-width:10rem;"
                    >
                        <template #body="slotProps">
                            <span class="p-column-title">Jurusan</span>
                            {{ slotProps.data.major }}
                        </template>
                    </Column>
                    <Column
                        field="Year"
                        header="Tahun"
                        :sortable="true"
                        headerStyle="width:70%; min-width:10rem;"
                    >
                        <template #body="slotProps">
                            <span class="p-column-title">Year</span>
                            {{ slotProps.data.year_of_entry }} - {{ slotProps.data.year_of_graduation }}
                        </template>
                    </Column>
                    <Column headerStyle="width:15%;min-width:10rem;">
                        <template #body="slotProps">
                            <Button
                                icon="pi pi-pencil"
                                class="p-button-rounded p-button-success mr-2"
                                @click="editModel(slotProps.data)"
                            />
                            <Button
                                icon="pi pi-trash"
                                class="p-button-rounded p-button-warning mt-2"
                                @click="confirmDeleteModel(slotProps.data)"
                            />
                        </template>
                    </Column>
                </DataTable>

                <Dialog
                    v-model:visible="modelDialog"
                    :style="{ width: '450px' }"
                    header="Formal Education Detail"
                    :modal="true"
                    class="p-fluid"
                >
                    <div class="field">
                        <label for="name">Nama Institusi</label>
                        <InputText
                            id="name"
                            v-model.trim="model.name"
                            required="true"
                            autofocus
                            placeholder="Contoh : SDIT Ulul Albab"
                            :class="{ 'p-invalid': submitted && !model.name }"
                        />
                        <small class="p-invalid" v-if="submitted && !model.name"
                            >Nama Institusi perlu diisi.</small
                        >
                    </div>
                    <div class="field">
                        <label for="location">Lokasi</label>
                        <InputText
                            id="location"
                            v-model.trim="model.location"
                            required="true"
                            autofocus
                            placeholder="Example : Bekasi, Jakarta"
                            :class="{ 'p-invalid': submitted && !model.location }"
                        />
                        <small class="p-invalid" v-if="submitted && !model.location"
                            >Lokasi perlu diisi.</small
                        >
                    </div>
                     <div class="field">
                        <label for="education_level">Level Pendidikan</label>
                        <Dropdown v-model="model.education_level" :options="lastEducationLevels" optionLabel="name" optionValue="id" placeholder="Pilih Level Pendidikan" :class="{'p-invalid' : submitted && !model.education_level}" />
                        <small class="p-invalid" v-if="submitted && !model.education_level"
                            >Level Pendidikan perlu diisi.</small
                        >
                    </div>
                    <div class="field">
                        <label for="education_level">Jurusan</label>
                        <InputText
                            id="major"
                            v-model.trim="model.major"
                            required="true"
                            autofocus
                            placeholder="Example : System Information"
                            :class="{ 'p-invalid': submitted && !model.major }"
                        />
                        <small class="p-invalid" v-if="submitted && !model.major"
                            >Jurusan perlu diisi.</small
                        >
                    </div>
                    <div class="field">
                        <label for="education_level">Tahun Masuk</label>
                        <InputText
                            id="year_of_entry"
                            v-model.trim="model.year_of_entry"
                            required="true"
                            autofocus
                            :class="{ 'p-invalid': submitted && !model.year_of_entry }"
                        />
                        <small class="p-invalid" v-if="submitted && !model.year_of_entry"
                            >Tahun Masuk perlu diisi.</small
                        >
                    </div>
                    <div class="field">
                        <label for="education_level">Tahun Lulus</label>
                        <InputText
                            id="year_of_graduation"
                            v-model.trim="model.year_of_graduation"
                            required="true"
                            autofocus
                            :class="{ 'p-invalid': submitted && !model.year_of_graduation }"
                        />
                        <small class="p-invalid" v-if="submitted && !model.year_of_graduation"
                            >Tahun Lulus perlu diisi.</small
                        >
                    </div>
                    <template #footer>
                        <Button
                            label="Cancel"
                            icon="pi pi-times"
                            class="p-button-text"
                            @click="hideDialog"
                        />
                        <Button
                            label="Save"
                            icon="pi pi-check"
                            class="p-button-text"
                            @click="saveModel"
                        />
                    </template>
                </Dialog>

                <Dialog
                    v-model:visible="deleteModelDialog"
                    :style="{ width: '450px' }"
                    header="Confirm"
                    :modal="true"
                >
                    <div class="flex align-items-center justify-content-center">
                        <i
                            class="pi pi-exclamation-triangle mr-3"
                            style="font-size: 2rem"
                        />
                        <span v-if="model"
                            >Are you sure you want to delete
                            <b>{{ model.name }}</b
                            >?</span
                        >
                    </div>
                    <template #footer>
                        <Button
                            label="No"
                            icon="pi pi-times"
                            class="p-button-text"
                            @click="deleteModelDialog = false"
                        />
                        <Button
                            label="Yes"
                            icon="pi pi-check"
                            class="p-button-text"
                            @click="deleteModel"
                        />
                    </template>
                </Dialog>

                <Dialog
                    v-model:visible="deleteModelsDialog"
                    :style="{ width: '450px' }"
                    header="Confirm"
                    :modal="true"
                >
                    <div class="flex align-items-center justify-content-center">
                        <i
                            class="pi pi-exclamation-triangle mr-3"
                            style="font-size: 2rem"
                        />
                        <span v-if="model"
                            >Are you sure you want to delete the selected
                            models?</span
                        >
                    </div>
                    <template #footer>
                        <Button
                            label="No"
                            icon="pi pi-times"
                            class="p-button-text"
                            @click="deleteModelsDialog = false"
                        />
                        <Button
                            label="Yes"
                            icon="pi pi-check"
                            class="p-button-text"
                            @click="deleteSelectedModels"
                        />
                    </template>
                </Dialog>
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios';
import { Head } from "@inertiajs/inertia-vue3";
import { FilterMatchMode } from "primevue/api";
import DataTable from "primevue/datatable";
import Dropdown from "primevue/dropdown";
import Column from "primevue/column";
import Dialog from "primevue/dialog";
import Button from "primevue/button";
import Toolbar from "primevue/toolbar";
import Toast from "primevue/toast";
import InputText from "primevue/inputtext";
import DatatableService from "../../../Services/DatatableService";

export default {
    components: {
        Head,
        DataTable,
        Dropdown,
        Column,
        Dialog,
        Button,
        Toolbar,
        Toast,
        InputText,
    },
    props: ['applicant'],
    data() {
        return {
            searchFilter: "",
            loading: true,
            totalRecords: 0,
            selectedModel: null,
            filters: null,
            model: {},
            modelDialog: false,
            models: [],
            lastEducationLevels: null,
            lazyParams: null,
            deleteModelDialog: false,
            deleteModelsDialog: false,
            selectedModels: null,
            submitted: false,
            selectAll: false,
        };
    },
    mounted() {
        this.loading = false;
        this.initData();
    },
    methods: {
        initData(){
            axios.get(this.route("education.levels"))
            .then((data) => {
                this.lastEducationLevels = data.data.data;
            })
            .catch((error) => {
                this.$toast.add({
                    severity: "error",
                    summary: "Error",
                    detail: error,
                    life: 3000,
                });
            })
        },
        onRowSelect() {
            this.selectAll = this.selectedModels.length === this.totalRecord;
        },
        onRowUnselect() {
            this.selectAll = false;
        },
        openNew() {
            this.model = {};
            this.submitted = false;
            this.modelDialog = true;
        },
        hideDialog() {
            this.modelDialog = false;
            this.submitted = false;
        },
        saveModel() {
            this.submitted = true;
            this.model.applicant_id = this.applicant.id;
            this.models.push(this.model);

            this.modelDialog = false;
            this.model = {};
        },
        editModel(model) {
            this.model = { ...model };
            this.modelDialog = true;
        },
        confirmDeleteModel(model) {
            this.model = model;
            this.deleteModelDialog = true;
        },
        deleteModel() {
            this.models = this.models.filter(val => val.name !== this.model.name);
            this.deleteModelDialog = false;
            this.model = {};
            this.$toast.add({severity:'success', summary: 'Successful', detail: 'Record Deleted', life: 3000});
        },
        confirmDeleteSelected() {
            this.deleteModelsDialog = true;
        },
        deleteSelectedModels() {
            this.models = this.models.filter(
                (val) => !this.selectedModels.includes(val)
            );
            this.deleteModelsDialog = false;
            this.selectedModels = null;
            this.$toast.add({
                severity: "success",
                summary: "Successful",
                detail: "Models Deleted",
                life: 3000,
            });
        },
    },
};
</script>
